import defaultState from './state';

const SAVE_USER_PROFILE = (state, userObj) => {
  state.loggedInUserProfile = userObj;
};

const DESTROY = (state) => {
  Object.keys(defaultState).forEach((key) => {
    state[key] = defaultState[key];
  });
};

const SAVE_ME_USAGE_STATISTICS = (state, res) => {
  state.usageStatistics = res;
};

export default {
  SAVE_USER_PROFILE,
  DESTROY,
  SAVE_ME_USAGE_STATISTICS
};



// WEBPACK FOOTER //
// ./src/store/modules/users/mutations.js